import { BaseModel } from './base';

export class   LeaveSetting extends BaseModel{
  maxNoOfDays: string;

  subscriberId: string;

  siteId: string;
}
